import { DEFAULT_FETCHING } from ".";
import { FetchingPaginationDataModel, EducationLevelStatus, CurrencyStatus } from "../models";

export const INITIAL_FETCHING_PAGINATION_DATA: FetchingPaginationDataModel<any> = {
  page: 1,
  totalPages: 1,
  limit: DEFAULT_FETCHING.LIMIT,
  totalRecords: 1,
  data: [],
  loading: false,
};

export const BLOG_CATEGORY = {
  PROMOTION: {
    id: "d19b021e-0977-4b25-a103-c6a792a3c886",
    slug: "khuyen-mai",
  },
};

export enum LANGUAGES {
  EN = "en",
  VN = "vn",
  CN = "cn",
}

export enum CATEGORY_TYPES {
  POST = "post",
  VIDEO = "video",
  SOLUTION = "solution",
  NEWS = "news",
}

// export const LanguageOptions: {
//   id: LANGUAGES;
//   label: string;
//   imgSrc: string;
// }[] = [
//   { id: LANGUAGES.EN, label: "English", imgSrc: AmericaImg },
//   { id: LANGUAGES.VN, label: "Tiếng Việt", imgSrc: VNImg },
//   { id: LANGUAGES.CN, label: "中国人", imgSrc: ChinaImg },
// ];

export const EducationOptions: {
  id: EducationLevelStatus;
  label: string;
}[] = [
  { id: EducationLevelStatus.ANY_LEVEL, label: "Any Level" },
  { id: EducationLevelStatus.HIGH_SCHOOL_OR_EQUIVALENT, label: "High School or Equivalent" },
  { id: EducationLevelStatus.ASSOCIATE_DEGREE, label: "Associate Degree" },
  { id: EducationLevelStatus.BACHELOR_DEGREE, label: "Bachelor Degree" },
  { id: EducationLevelStatus.MASTER_DEGREE, label: "Master Degree" },
  { id: EducationLevelStatus.DOCTORATE_DEGREE, label: "Doctorate Degree" },
  { id: EducationLevelStatus.NONE, label: "None" },
];

export const CurrencyOptions: {
  id: CurrencyStatus;
  name: string;
  locale: string;
}[] = [
  { id: CurrencyStatus.VND, name: "Vietnamese Dong", locale: "vi-VN" },
  { id: CurrencyStatus.CNY, name: "China Yuan Renminbi", locale: "zh-CN" },
  { id: CurrencyStatus.EUR, name: "Euro", locale: "en-IE" },
  { id: CurrencyStatus.USD, name: "United State Dollar", locale: "en-US" },
  { id: CurrencyStatus.GBP, name: "Pound Sterling", locale: "en-GB" },
];
